import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import {
  selectAuthInfo,
  selectAuthInitialized,
} from '../store/user/user.selectors';

export const authGuard = () => {
  const navigationService = inject(NavigationService);
  const store = inject(Store);

  return combineLatest([
    store.select(selectAuthInfo),
    store.select(selectAuthInitialized),
  ]).pipe(
    filter(([_, authInitialized]) => authInitialized),
    take(1),
    map(([authInfo]) => {
      if (authInfo?.uid) {
        return true;
      }
      navigationService.navigateToWelcome();
      return false;
    })
  );
};
